import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { beratungAPI } from '@/lib/api';
import { CalendarX, CheckCircle2, Loader2 } from 'lucide-react';

// Öffentliche, token-gesicherte Absageseite (Link aus der Bestätigungs-Mail).
const P1_RED = '#d1272e';

export default function BeratungAbsagePage() {
  const { token } = useParams();
  const [state, setState] = useState('confirm'); // confirm | busy | done | error

  const absagen = async () => {
    setState('busy');
    try {
      await beratungAPI.absagen(token);
      setState('done');
    } catch {
      setState('error');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" style={{ fontFamily: "'Manrope', sans-serif" }} data-testid="beratung-absage-page">
      <div className="max-w-md w-full">
        <div className="flex justify-center mb-6">
          <img src="/logo-black.png" alt="P1 Performance Center" className="h-9 object-contain" />
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 p-8 text-center">
          {state === 'confirm' && (
            <>
              <CalendarX className="w-10 h-10 mx-auto mb-3" style={{ color: P1_RED }} />
              <h1 className="text-xl font-extrabold">Termin absagen?</h1>
              <p className="text-sm text-gray-500 mt-2">Deine Erstberatung wird storniert und der Termin wieder freigegeben. Du kannst jederzeit einen neuen Termin buchen.</p>
              <button onClick={absagen} data-testid="absage-confirm"
                className="mt-6 w-full h-13 py-4 rounded-xl text-white text-base font-extrabold" style={{ backgroundColor: P1_RED }}>
                Ja, Termin absagen
              </button>
              <a href="/buchung/beratung" className="block mt-3 text-sm text-gray-500 underline">Zurück zur Buchung</a>
            </>
          )}
          {state === 'busy' && <Loader2 className="w-8 h-8 animate-spin mx-auto" style={{ color: P1_RED }} />}
          {state === 'done' && (
            <>
              <CheckCircle2 className="w-10 h-10 mx-auto mb-3 text-emerald-500" />
              <h1 className="text-xl font-extrabold" data-testid="absage-done">Termin abgesagt</h1>
              <p className="text-sm text-gray-500 mt-2">Schade! Du kannst dir jederzeit einen neuen Termin sichern.</p>
              <a href="/buchung/beratung" data-testid="absage-rebook"
                className="mt-6 inline-block w-full py-4 rounded-xl text-white text-base font-extrabold" style={{ backgroundColor: P1_RED }}>
                Neuen Termin buchen
              </a>
            </>
          )}
          {state === 'error' && (
            <>
              <CalendarX className="w-10 h-10 mx-auto mb-3 text-gray-300" />
              <h1 className="text-xl font-extrabold">Link ungültig</h1>
              <p className="text-sm text-gray-500 mt-2">Dieser Absage-Link ist ungültig oder der Termin wurde bereits abgesagt.</p>
              <a href="/buchung/beratung" className="mt-6 inline-block text-sm underline" style={{ color: P1_RED }}>Zur Terminbuchung</a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
